export default __webpack_public_path__ + "static/experience-pic-04-6daba42e1092418102e1db5efcb0ef08.jpg";